import React from 'react';
import PropTypes from 'prop-types';
import { t } from 'ttag';

import { mergeClasses } from '@utils';

// Turn on to label AI generated and modified images on the page (EU AI Act Art. 50(4)).
export const DISPLAY_AI_GENERATED_LABELS = false;

// Image.AiDisclosure's shapes from the Next.js frontend, with roomier padding. The extra
// pixel on top centres the uppercase letters optically.
const SHAPE_CLASSES = {
  never:
    'h-auto w-fit gap-1 whitespace-nowrap px-2.5 pb-[5px] pt-1.5 text-xs tracking-wider',
  mobile:
    'h-auto w-fit gap-1 whitespace-nowrap px-2 pb-1 pt-[5px] text-[10px] tracking-normal md:px-2.5 md:pb-[5px] md:pt-1.5 md:text-xs md:tracking-wider',
  always:
    'h-auto w-fit gap-1 whitespace-nowrap px-2 pb-1 pt-[5px] text-[10px] tracking-normal'
};

/**
 * An "AI Generated" or "AI Modified" label over an image, matching the Next.js
 * frontend's Image.AiDisclosure. Place it in a positioned parent; it sits in the top
 * right corner unless `className` moves it.
 */
export default function AiLabel({ level, compact, className }) {
  if (!DISPLAY_AI_GENERATED_LABELS) return null;

  return (
    <span
      className={mergeClasses(
        'pointer-events-none absolute right-2 top-2 z-10 flex items-center justify-center rounded-full bg-[#858585]/40 uppercase leading-none text-white',
        SHAPE_CLASSES[compact === true ? 'always' : compact || 'never'],
        className
      )}
    >
      {/* The space keeps the words apart for screen readers; the gap spaces them visually. */}
      <span className="font-extrabold">AI</span>{' '}
      <span className="font-bold">
        {level === 'ai_generated' ? t`Generated` : t`Modified`}
      </span>
    </span>
  );
}

AiLabel.propTypes = {
  level: PropTypes.oneOf(['ai_modified', 'ai_generated']),
  compact: PropTypes.oneOf([true, false, 'mobile']),
  className: PropTypes.string
};

AiLabel.defaultProps = {
  level: 'ai_generated',
  compact: false,
  className: ''
};
